import * as moment from "moment";
import { ConsultationDetails as CommonConsultationDetails } from "@teamprevent/common/model";

import { Link, TaskTypeLabel, TaskTypes } from "../task/taskActions/models";
import { ServerModelWithDateStrings } from "../utils";

export type ConsultationDetails = CommonConsultationDetails & { successorTasks?: TaskType[] };

export interface ConsultationDetailsState {
    readonly consultationDetails: ConsultationDetails[];
}

export function parseConsultationModel(model: ServerModelWithDateStrings<ConsultationDetails>): ConsultationDetails {
    return {
        ...model,
        consultationDate: model.consultationDate ? moment(model.consultationDate) : null
    };
}

export interface TaskType {
    description: string;
    type: string;
    label?: TaskTypeLabel;
    typeId: keyof typeof TaskTypes;
    visibleForCaseTypes?: string[];
    subTasks: string[];
    dueDateApplicable: boolean;
    maximumNumberOfDaysDueDateCanBeInFuture: number;
    closesCase: boolean;
    isBookTask: boolean;
    immunisationTaskType: ImmunisationTaskType;
    sortNumber: number;
    notesRequired: boolean;
    taskCategories: string[];
    emailTemplate?: Link;
}

export enum ImmunisationTaskType {
    Evidence = "ImmunisationEvidenceTask",
    BloodTest = "ImmunisationBloodTestTask",
    Vaccine = "ImmunisationVaccineTask",
    Results = "ImmunisationResultsTask",
    NoFurtherAction = "NoFurtherActionTask"
}
